import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const espoCrm = defineConnector({
  identifier: "espoCrm",
  name: "EspoCRM",
  tagLine: "Open source CRM platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.espocrm\\.com/.*",
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your EspoCRM instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "crm.your-company.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In EspoCRM, go to **Administration › API Users** and create an API user with an API key. See the [API docs](https://docs.espocrm.com/development/api/) for details.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v1/App/user`,
  },
});
